import { Component, input, signal } from '@angular/core'


// These map to directives, e.g. icon-small, etc
export enum IconSize {
  Inherit = 'inherit',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xlarge',
}

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: false,
})
export class IconComponent {
  IconSize = IconSize

  styleOverrides = input<any>({})

  size = signal<IconSize>(IconSize.Inherit)
}
